module.exports = __webpack_public_path__ + "static/firefox_icon-6701b54f6d8defbad2a98034e2178e7d.svg";